import React, { useState, useEffect } from 'react';

const EasterEggs = () => {
  const [konami, setKonami] = useState([]);
  const [showSecret, setShowSecret] = useState(false);
  const konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];

  useEffect(() => {
    const handleKeyDown = (e) => {
      setKonami(prev => {
        const newKonami = [...prev, e.key];
        if (newKonami.length > konamiCode.length) {
          newKonami.shift();
        }
        if (newKonami.join(',') === konamiCode.join(',')) {
          setShowSecret(true);
          document.documentElement.classList.add('matrix-mode');
        }
        return newKonami;
      });
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return showSecret ? (
    <div className="fixed inset-0 pointer-events-none z-50">
      <div className="matrix-rain" />
    </div>
  ) : null;
};

export default EasterEggs; 